import { useForm } from 'react-hook-form';
import Footer from '../../../commons/Footer/Footer';
import Form from '../../../commons/Form/Form';
import Menu from '../../../commons/Menu/Menu';
import { contactData } from './Contact.data';
import { ContactFormSchema } from './Contact.types';
import { yupResolver } from '@hookform/resolvers/yup';
import { getContactSchema } from './Contact.schema';
import { useMutation, useQueryClient } from 'react-query';
import { BaseResponse } from '../../../../types/api/api.types';
import { CONTACT_MESSAGE_QUERY_KEY, contactMessageQuery } from './Contact.query';
import { useNavigate } from 'react-router-dom';

export default () => {

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const formProps = useForm<ContactFormSchema>({
    resolver: yupResolver(getContactSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, ContactFormSchema>(
    (data) => contactMessageQuery(data),
    {
      mutationKey: CONTACT_MESSAGE_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ message }) => {
        alert(message);
        navigate('/')
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <div className="fullscreen">
      <Menu />
      <Form<ContactFormSchema>
        data={contactData}
        {...{ formProps, onSubmit }}
        buttonLabel="Envoyer"
      />
      <Footer />
    </div>
  );
};
